/**************************************************
 * Nombre:       Calendario_Calendario
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import '@splidejs/react-splide/css';
import {theme} from "../../../Tema";
import {GRADIENTE} from "../../../Constantes";
import Calentadario from "./SubComponentes/Calentadario";
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {formatoFechaDays} from "../../../Utilidades/formatoFechaDays";
import {irUrl} from "../../../Utilidades/irUrl";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {obtenerProximoEvento} from "../../../CodigoNegocio/Eventos/obtenerProximoEvento";
import {obtenerEventosFecha} from "../../../CodigoNegocio/Eventos/obtenerEventosFecha";
import Tarjeta_Evento_Calendario from "../../Tarjetas/Tarjeta_Evento_Calendario";


const Calendario_Calendario = () => {
    const {sCell} = useResponsive()
    const [eventos, setEventos] = useState([]);
    const [escogido, setEscogido] = useState({});
    const [index, setIndex] = useState()
    const [ultimoEvento, setultimoEvento] = useState({});
    const [eventosDia, setEventosDia] = useState([]);

    const escogerDia = async (e) => {



        let doxEventos = await obtenerEventosFecha(e.fecha)
        console.log(doxEventos)
        setEventosDia(doxEventos)


    }


    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'eventos', wheres: w}).then((dox) => {
            setEventos(dox.data)

            let index = dox.data.findIndex((e) => e.fecha >= new Date().getTime())
            if (index > -1) {
                setIndex(index)
            }

        })

        obtenerProximoEvento().then(dox => {
            setultimoEvento(dox)
            setEscogido(dox)
        })


    }, []);
    useEffect(() => {
        if (eventos.length > 0 && index <= eventos.length) {
            setEscogido(eventos[index])
        } else {
            setIndex(index)
        }

    }, [index, eventos])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                overflowX: 'hidden',

            }}
        >
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: 8, mb: 12}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <Typography
                                        sx={{
                                            color: '#262626',
                                            fontSize: sCell ? 32 : 34,
                                            fontWeight: 700,
                                            textAlign: 'center',
                                            lineHeight: 1
                                        }}>
                                        Calendario de Eventos
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 5}}
                                      sx={{justifyContent: 'center', mt: sCell ? 1 : 0}}>
                                    <Typography
                                        sx={{color: '#545454', fontSize: 16, fontWeight: 400, textAlign: 'center'}}>
                                        Próximos entrenamientos y actividades
                                    </Typography>
                                </Grid>


                            </Grid>

                        </Grid>


                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? -6 : 0}}>
                            <Calentadario eventos={eventos} setEscogido={escogerDia} escogido={escogido}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                {eventosDia.map((item, index) => {
                                    return(
                                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                                            <Tarjeta_Evento_Calendario item={item} />
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-end', mt: sCell ? 2 : -12}}>
                            <Grid
                                container
                                justifyContent={'flex-end'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={2}
                            >

                            </Grid>


                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Calendario_Calendario

const items = [1, 2]